import React from 'react';

const HomeworkAssignmentSuccess = ({ 
  title, 
  dueDate, 
  className, 
  questions, 
  selectedForms,
  onReset 
}) => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      <div className="text-center mb-6">
        <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-green-600 mb-2">
          Homework Assigned Successfully!
        </h2>
        <p className="text-gray-600">
          Your homework has been created and assigned to students.
        </p>
      </div>

      <div className="bg-gray-50 rounded-lg p-6 mb-6">
        <h3 className="text-lg font-semibold mb-4 text-gray-800">Assignment Details</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <span className="font-medium text-gray-700">Title:</span>
            <p className="text-gray-600">{title}</p>
          </div>
          
          <div>
            <span className="font-medium text-gray-700">Due Date:</span>
            <p className="text-gray-600">{dueDate}</p>
          </div>
          
          <div>
            <span className="font-medium text-gray-700">Subject:</span>
            <p className="text-gray-600">{className}</p>
          </div>
          
          <div>
            <span className="font-medium text-gray-700">Number of Questions:</span>
            <p className="text-gray-600">{questions?.length || 0}</p>
          </div>
        </div>

        <div>
          <span className="font-medium text-gray-700">Assigned to Forms:</span>
          <div className="flex flex-wrap gap-2 mt-2">
            {selectedForms && selectedForms.length > 0 ? (
              selectedForms.map((form, index) => (
                <span 
                  key={index}
                  className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm"
                >
                  {form}
                </span>
              ))
            ) : (
              <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-sm">
                {className || "No forms selected"}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="bg-blue-50 rounded-lg p-4 mb-6">
        <div className="flex items-center">
          <svg className="w-5 h-5 text-blue-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <div>
            <p className="text-blue-800 font-medium">What happens next?</p>
            <p className="text-blue-700 text-sm">
              Students can now access this homework from their dashboard and submit their answers before the due date.
            </p>
          </div>
        </div>
      </div>

      <div className="text-center">
        <button
          onClick={onReset}
          className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors font-medium"
        >
          Create Another Homework
        </button>
      </div>
    </div>
  );
};

export default HomeworkAssignmentSuccess;
